import type { SponsorOutgoingAttachments } from '@/contract/sponsor.schema'

/** Spec PWA-013 D-01 — corpo do envio de mensagem. Sem anexo: JSON, como antes. Com foto ou audio: um pedido so em
    multipart, com os campos `body`, `photo` e `audio` (o navegador define o Content-Type com o boundary).
    Spec PWA-018 D-02 — com audio, vai tambem o idioma do app (`locale`), para transcrever no idioma certo.
    Spec PWA-020 D-09 — e o idioma vai tambem no envio so de texto (a OSP e o admin traduzem a partir dele). */
export function messagePayload(body: string, { photo, audio }: SponsorOutgoingAttachments, locale?: string): FormData | { body: string; locale?: string } {
    if (!photo && !audio) return locale ? { body, locale } : { body }
    const form = new FormData()
    form.append('body', body)
    if (photo) form.append('photo', photo, 'foto.jpg')
    if (audio) form.append('audio', audio, 'audio')
    if (locale) form.append('locale', locale)
    return form
}
